import { LegalLayout, LegalSection } from "@/pages/LegalPage";

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" updated="June 2026">
      <p className="text-[15px]" data-testid="privacy-intro">
        Tugboat ("we", "us") provides an embeddable beta-feedback widget and dashboard. This policy explains what we
        collect, why, and the choices you have. For feedback submitted through a customer's widget, that customer is the
        data controller and Tugboat acts as a data processor on their behalf.
      </p>

      <LegalSection heading="What we collect">
        <p><b>Account data</b> (developers): name, email, and a securely hashed password (or your Google profile if you sign in with Google).</p>
        <p><b>Feedback submissions</b> (testers): the content you choose to send — screenshots, screen recordings, voice notes, and text — plus any name or email you optionally provide.</p>
        <p><b>Technical context</b>: the page URL where feedback was captured, your browser user-agent, and an approximate location (country, region, city) derived from your IP address. We do <b>not</b> store your full IP address.</p>
      </LegalSection>

      <LegalSection heading="Camera, screen & microphone">
        <p>
          Screen recording and voice capture only happen after your browser asks for, and you grant, explicit permission.
          You can decline at any time, and nothing is captured unless you press record and submit. Tugboat never accesses
          your screen or microphone in the background.
        </p>
      </LegalSection>

      <LegalSection heading="How we use it">
        <p>To deliver the service: routing feedback to the right project dashboard, playing back media, enabling triage,
          tags, status and integrations (e.g. creating a Jira issue when you click "Send to Jira"), and aggregate analytics
          for the workspace owner.</p>
      </LegalSection>

      <LegalSection heading="Storage & retention">
        <p>Media is stored in encrypted object storage; metadata in our database. Feedback is retained until the workspace
          owner deletes it. Account data is kept while your account is active.</p>
      </LegalSection>

      <LegalSection heading="Sharing">
        <p>We share data only with infrastructure providers needed to run the service, and with third-party tools you
          explicitly connect (such as Jira). We do not sell personal data.</p>
      </LegalSection>

      <LegalSection heading="Your rights (GDPR / CCPA)">
        <p>You may request access, correction, export, or deletion of your personal data. For feedback you submitted via a
          widget, contact the company whose product you were testing, or reach us and we'll route the request. Email{" "}
          <a href="mailto:hello@tugboatapp.com" className="text-orange font-700">hello@tugboatapp.com</a>.</p>
      </LegalSection>

      <LegalSection heading="Contact">
        <p>Questions? <a href="mailto:hello@tugboatapp.com" className="text-orange font-700">hello@tugboatapp.com</a></p>
      </LegalSection>
    </LegalLayout>
  );
}
